export const queryOptions = {
  refetchInterval: 10000000000000,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
};

export const colors: any = [
  '--color-chart-line-01',
  '--color-chart-line-02',
  '--color-chart-line-03',
  '--color-chart-line-04',
  '--color-chart-line-05',
  '--color-chart-line-06',
  '--color-chart-line-07',
  '--color-chart-line-08',
  '--color-chart-line-09',
  '--color-chart-line-10',
  '--color-chart-line-11',
  '--color-chart-line-12',
  '--color-chart-line-13',
  '--color-chart-line-14',
  '--color-chart-line-15',
  '--color-chart-line-16',
  '--color-chart-line-17',
  '--color-chart-line-18',
  '--color-chart-line-19',
  '--color-chart-line-20',
  '--color-chart-line-21',
  '--color-chart-line-22',
  '--color-chart-line-23',
  '--color-chart-line-24',
  '--color-chart-line-25',
  '--color-chart-line-26',
  '--color-chart-line-27',
  '--color-chart-line-28',
  '--color-chart-line-29',
  '--color-chart-line-30',
  '--color-chart-line-31',
  '--color-chart-line-32',
  '--color-chart-line-33',
  '--color-chart-line-34',
  '--color-chart-line-35',
  '--color-chart-line-36',
  '--color-chart-line-37',
  '--color-chart-line-38',
  '--color-chart-line-39',
  '--color-chart-line-40',
  '--color-chart-line-41',
  '--color-chart-line-42',
  '--color-chart-line-43',
  '--color-chart-line-44',
  '--color-chart-line-45',
  '--color-chart-line-46',
  '--color-chart-line-47',
  '--color-chart-line-48',
  '--color-chart-line-49',
  '--color-chart-line-50',
  '--color-chart-line-51',
  '--color-chart-line-52',
  '--color-chart-line-53',
  '--color-chart-line-54',
  '--color-chart-line-55',
  '--color-chart-line-56',
  '--color-chart-line-57',
];

export const plotBandOpacity = 0.2; // values between 0 and 1.

export const searchData: any = [
  {
    category: 'Baskets',
    type: 'keyValue',
    path: '/Dashboards%20&%20Apps/Apps/MediaStatsBaskets?Date={date}',
    data: [
      {
        appId: 'Iran',
        label: 'Iran',
        date: '2022-09-30',
        name: 'Iran - deal, nuclear, sanctions, leaders',
        flag: '',
      },
      {
        appId: 'Manufacturing',
        label: 'Manufacturing',
        date: '2023-02-28',
        name: 'ISM Manufacturing Index - measures the change in production levels across the U.S. economy',
        flag: '',
      },
      {
        appId: 'Income Inequality',
        label: 'Income Inequality',
        date: '2022-04-30',
        name: 'Measures how unevenly income or income growth is distributed across the population',
        flag: '',
      },
      {
        appId: 'National Security',
        label: 'National Security',
        date: '2023-03-31',
        name: 'U.S National security',
        flag: '',
      },
      {
        appId: 'BitcoinTopic',
        label: 'Bitcoin',
        date: '2022-05-31',
        name: 'Bitcoin decentralized digital currency ecosystem',
        flag: '',
      },
      {
        appId: 'Consumer Spending',
        label: 'Consumer Spending',
        date: '2023-03-31',
        name: 'When consumers spend money',
        flag: '',
      },
      {
        appId: 'Job Market',
        label: 'Job Market',
        date: '2023-03-31',
        name: 'The job market',
        flag: '',
      },
      {
        appId: 'Physical Retail',
        label: 'Physical Retail',
        date: '2022-05-31',
        name: 'A physical store, often referred to as a brick-and-mortar store, is a retail environment that requir',
        flag: '',
      },
      {
        appId: 'Luxury Retail',
        label: 'Luxury Retail',
        date: '2022-12-31',
        name: 'Luxury retail - stores, brands, products',
        flag: '',
      },
      {
        appId: 'Holiday Shopping',
        label: 'Holiday Shopping',
        date: '2022-12-31',
        name: 'Shopping & Holidays',
        flag: '',
      },
      {
        appId: 'Military Escalation',
        label: 'Military Escalation',
        date: '2022-08-31',
        name: '',
        flag: '',
      },
      {
        appId: 'Gasoline Price',
        label: 'Gasoline Price',
        date: '2022-09-30',
        name: 'Gasoline prices',
        flag: '',
      },
      {
        appId: 'Food Prices',
        label: 'Food Prices',
        date: '2022-12-31',
        name: 'Food costs, prices, and inflation',
        flag: '',
      },
      {
        appId: 'Meat Prices',
        label: 'Meat Prices',
        date: '2022-10-31',
        name: 'Meat costs, prices, demand, sales',
        flag: '',
      },
      {
        appId: 'Fruit and Vegetable Prices',
        label: 'Fruit & Vegetable Prices',
        date: '2022-04-30',
        name: 'Fruit & vegetables costs, prices, and sales',
        flag: '',
      },
      {
        appId: 'Dairy Prices',
        label: 'Dairy Prices',
        date: '2022-11-30',
        name: 'Cost of basic dairy goods, demand for them, prices, and sales',
        flag: '',
      },
      {
        appId: 'Food Shortage',
        label: 'Food Shortage',
        date: '2022-06-30',
        name: 'Food Shortage',
        flag: '',
      },
      {
        appId: 'Apparel Prices',
        label: 'Apparel Prices',
        date: '2022-06-30',
        name: 'The combining measures that affect apparel costs',
        flag: '',
      },
      {
        appId: 'Carbon Emissions',
        label: 'Carbon Emissions',
        date: '2021-12-31',
        name: 'Carbon dioxide (CO2) emitted when fossil fuels are burned',
        flag: '',
      },
      {
        appId: 'Carbon Footprint',
        label: 'Carbon Footprint',
        date: '2021-12-31',
        name: 'A measure of the impact your activities have on the amount of carbon dioxide (CO2) produced through ',
        flag: '',
      },
      {
        appId: 'Copper',
        label: 'Copper',
        date: '2022-07-31',
        name: 'Copper ecosystem, market and prices',
        flag: '',
      },
      {
        appId: 'Aluminium',
        label: 'Aluminium',
        date: '2021-11-30',
        name: 'Aluminum ecosystem, market and prices',
        flag: '',
      },
      {
        appId: 'Steel',
        label: 'Steel',
        date: '2022-04-30',
        name: 'Steel prices',
        flag: '',
      },
      {
        appId: 'Coffee',
        label: 'Coffee',
        date: '2021-11-30',
        name: 'Coffee ecosystem and prices',
        flag: '',
      },
      {
        appId: 'Corn',
        label: 'Corn',
        date: '2022-04-30',
        name: 'Corn ecosystem, market and prices',
        flag: '',
      },
      {
        appId: 'Wheat',
        label: 'Wheat',
        date: '2022-06-30',
        name: 'Wheat prices',
        flag: '',
      },
      {
        appId: 'Soybean',
        label: 'Soybean',
        date: '2022-06-30',
        name: 'Soybean prices',
        flag: '',
      },
      {
        appId: 'Cattle',
        label: 'Cattle',
        date: '2021-12-31',
        name: 'Cattle are large ruminant animals, domesticated for meat or milk',
        flag: '',
      },
      {
        appId: 'Droughts',
        label: 'Droughts',
        date: '2021-11-30',
        name: 'A prolonged period of abnormally low rainfall, leading to a shortage of water',
        flag: '',
      },
      {
        appId: 'Earthquakes',
        label: 'Earthquakes',
        date: '2023-02-28',
        name: 'A sudden and violent shaking of the ground',
        flag: '',
      },
      {
        appId: 'Fossil Fuels',
        label: 'Fossil Fuels',
        date: '2022-04-30',
        name: "A fossil fuel is a hydrocarbon-containing material formed naturally in the Earth's crust from the re",
        flag: '',
      },
      {
        appId: 'Smart CityTopic',
        label: 'Smart City',
        date: '2022-12-31',
        name: 'A smart city is a technologically modern urban area that uses different types of electronic methods ',
        flag: '',
      },
      {
        appId: 'Streaming Economy',
        label: 'Streaming Economy',
        date: '2022-10-31',
        name: 'Streaming economy - platforms, content, entertainment, and prices',
        flag: '',
      },
      {
        appId: 'Drug Prices',
        label: 'Drug Prices',
        date: '2022-09-30',
        name: 'Drug Prices',
        flag: '',
      },
      {
        appId: 'Hydrogen Fuel',
        label: 'Hydrogen Fuel',
        date: '2022-10-31',
        name: 'Hydrogen fuel ecosystem',
        flag: '',
      },
      {
        appId: 'International Trade',
        label: 'International Trade',
        date: '2022-07-31',
        name: 'International trade - import, export, supply chain, ports, price, tax',
        flag: '',
      },
      {
        appId: 'Bonds',
        label: 'Bonds',
        date: '2023-03-31',
        name: 'A security under which the issuer owes the holder a debt, and is obliged – depending on the terms – ',
        flag: '',
      },
      {
        appId: 'Commodities',
        label: 'Commodities',
        date: '2022-07-31',
        name: 'Commodities ecosystem, market and prices',
        flag: '',
      },
      {
        appId: 'Interest Rate',
        label: 'Interest Rate',
        date: '2023-03-31',
        name: 'Interest rates',
        flag: '',
      },
      {
        appId: 'Housing Market',
        label: 'Housing Market',
        date: '2023-02-28',
        name: 'Housing market, sales, construction',
        flag: '',
      },
      {
        appId: 'Bankruptcy',
        label: 'Bankruptcy',
        date: '2023-03-31',
        name: 'Bankruptcy is a legal process through which people or other entities who cannot repay debts to credi',
        flag: '',
      },
      {
        appId: 'Value Investing',
        label: 'Value Investing',
        date: '2022-02-28',
        name: 'Value investing is buying stocks which trade at a significant discount to their intrinsic value',
        flag: '',
      },
      {
        appId: 'Personal Finance',
        label: 'Personal Finance',
        date: '2023-03-31',
        name: 'Personal finance is the financial management which an individual or a family unit performs to budget',
        flag: '',
      },
      {
        appId: 'Crime Rate',
        label: 'Crime Rate',
        date: '2023-03-31',
        name: 'Measures the magnitude and impact of crime',
        flag: '',
      },
      {
        appId: 'ETFs',
        label: 'ETFs',
        date: '2023-02-28',
        name: 'Exchange Traded Fund',
        flag: '',
      },
      {
        appId: 'Money Market',
        label: 'Money Market',
        date: '2022-06-30',
        name: 'The money market is a component of the economy that provides short-term funds. The money market deal',
        flag: '',
      },
      {
        appId: 'Asset Management FundsTopic',
        label: 'Asset Management Funds',
        date: '2023-03-31',
        name: 'Asset management funds',
        flag: '',
      },
      {
        appId: 'Passive Investing',
        label: 'Passive Investing',
        date: '2022-11-30',
        name: 'Passive investing is an investment strategy to maximize returns by minimizing buying and selling',
        flag: '',
      },
      {
        appId: 'Quality Investing',
        label: 'Quality Investing',
        date: '2023-02-28',
        name: 'Quality investing is an investment strategy based on a set of clearly defined fundamental criteria t',
        flag: '',
      },
      {
        appId: 'Momentum Investing',
        label: 'Momentum Investing',
        date: '2023-01-31',
        name: 'Momentum investing is a strategy that aims to capitalize on the continuance of an existing market tr',
        flag: '',
      },
      {
        appId: 'Inflation',
        label: 'Inflation',
        date: '2023-01-31',
        name: 'Inflation is a sustained increase in the general level of prices for goods and services',
        flag: '',
      },
      {
        appId: 'ImmigrationTopic',
        label: 'Immigration',
        date: '2023-01-31',
        name: 'Immigration',
        flag: '',
      },
      {
        appId: 'HealthcareTopic',
        label: 'Healthcare',
        date: '2023-03-31',
        name: 'Healthcare - United States government health programs',
        flag: '',
      },
      {
        appId: 'Privacy Narrative',
        label: 'Privacy Narrative',
        date: '2022-02-28',
        name: 'Covering privacy laws, breaches, personal information, data protection and regulations',
        flag: '',
      },
      {
        appId: 'RecessionWaves',
        label: 'Recession',
        date: '2023-03-31',
        name: 'Recession',
        flag: '',
      },
      {
        appId: 'Market Crash',
        label: 'Market Crash',
        date: '2022-12-31',
        name: 'Market crash is a rapid and often unanticipated drop in stock prices',
        flag: '',
      },
      {
        appId: 'DividendsTopic',
        label: 'Dividends',
        date: '2022-08-31',
        name: 'Dividends Factor',
        flag: '',
      },
      {
        appId: 'Buybacks',
        label: 'Buybacks',
        date: '2023-03-31',
        name: 'When a corporation purchases its own shares in the stock market',
        flag: '',
      },
      {
        appId: 'Worker Hiring',
        label: 'Worker Hiring',
        date: '2022-07-31',
        name: 'Hiring or recruiting staff, which represents demand on the labor market',
        flag: '',
      },
      {
        appId: 'Consumer Savings',
        label: 'Consumer Savings',
        date: '2022-12-31',
        name: 'When consumers set aside money for future use',
        flag: '',
      },
      {
        appId: 'Ethereum',
        label: 'Ethereum',
        date: '2022-09-30',
        name: 'Ethereum decentralized digital currency ecosystem',
        flag: '',
      },
      {
        appId: 'Volatility',
        label: 'Volatility',
        date: '2022-11-30',
        name: 'Volatility is the degree of variation of a trading price series over time',
        flag: '',
      },
      {
        appId: 'Chip Shortage',
        label: 'Chip Shortage',
        date: '2021-12-31',
        name: 'Referred to as semiconductor shortage or chip famine, is a phenomenon in the integrated circuit indu',
        flag: '',
      },
      {
        appId: 'Mortgage',
        label: 'Mortgage',
        date: '2023-01-31',
        name: 'Mortgages',
        flag: '',
      },
      {
        appId: 'Taxes',
        label: 'Taxes',
        date: '2022-12-31',
        name: 'Taxes are mandatory contributions levied on individuals or corporations by a government entity',
        flag: '',
      },
      {
        appId: 'CashFlow',
        label: 'Cash Flow',
        date: '2021-11-30',
        name: 'The total amount of money being transferred into and out of a business, especially as affecting liqu',
        flag: '',
      },
      {
        appId: 'Supply Chain',
        label: 'Supply Chain',
        date: '2022-03-31',
        name: 'The sequence of processes involved in the production and distribution of a commodity',
        flag: '',
      },
      {
        appId: 'Container Shortage',
        label: 'Container Shortage',
        date: '2021-12-31',
        name: 'Shipping container shortage',
        flag: '',
      },
      {
        appId: 'Robotics',
        label: 'Robotics',
        date: '2023-03-31',
        name: 'Robotics is an interdisciplinary field dedicated to the design, construction, and use of robots',
        flag: '',
      },
      {
        appId: 'Cybersecurity',
        label: 'Cybersecurity',
        date: '2023-02-28',
        name: 'Cyber security ecosystem',
        flag: '',
      },
      {
        appId: 'Digital Economy',
        label: 'Digital Economy',
        date: '2023-02-28',
        name: 'The Digital Economy ecosystem',
        flag: '',
      },
      {
        appId: 'Disruptive Technology',
        label: 'Disruptive Technology',
        date: '2023-03-31',
        name: 'Disruptive innovation creates a new market or enters at the bottom of an existing one and eventually',
        flag: '',
      },
      {
        appId: 'Future Mobility',
        label: 'Future Mobility',
        date: '2022-08-31',
        name: 'Autonomous, Connected, Electric and Shared (ACES) Vehicles',
        flag: '',
      },
      {
        appId: 'Fintech',
        label: 'Fintech',
        date: '2023-03-31',
        name: 'Fintech & Innovation - Digital, Online, Advertising, Payments',
        flag: '',
      },
      {
        appId: 'Genomic Innovation',
        label: 'Genomic Innovation',
        date: '2022-05-31',
        name: 'Genome innovation - therapy, analytics, editing, agriculture, biotechnology',
        flag: '',
      },
      {
        appId: 'Autonomous Technology',
        label: 'Autonomous Technology',
        date: '2023-01-31',
        name: 'The field of building technology that can perform tasks without human intervention',
        flag: '',
      },
      {
        appId: 'Aging Society',
        label: 'Aging Society',
        date: '2023-03-31',
        name: 'The effect taking place as a result of increasing of median age in a population',
        flag: '',
      },
      {
        appId: 'Future Education',
        label: 'Future Education',
        date: '2023-03-31',
        name: 'Future education',
        flag: '',
      },
      {
        appId: 'Millennials',
        label: 'Millennials',
        date: '2022-11-30',
        name: 'Millennial, also known as Generation Y, became adults around the time of the millennium. Millennials',
        flag: '',
      },
      {
        appId: 'SPAC',
        label: 'SPAC',
        date: '2021-11-30',
        name: 'A special Purpose Acquisition Company is a shell corporation listed on a stock exchange with the pur',
        flag: '',
      },
      {
        appId: 'Renewable Energy',
        label: 'Renewable Energy',
        date: '2023-02-28',
        name: 'Energy that comes from renewable, zero emission sources, that are naturally replenished ',
        flag: '',
      },
      {
        appId: 'Green Building',
        label: 'Green Building',
        date: '2023-03-31',
        name: 'Green building & renovating',
        flag: '',
      },
      {
        appId: 'Clean Tech',
        label: 'Clean Tech',
        date: '2022-10-31',
        name: 'Environmentally-friendly practices and technologies that reduces negative environmental impacts',
        flag: '',
      },
      {
        appId: 'Water Stress',
        label: 'Water Stress',
        date: '2022-09-30',
        name: 'Lack of fresh water resources to meet the standard water demand',
        flag: '',
      },
      {
        appId: 'Climate Change',
        label: 'Climate Change',
        date: '2021-12-31',
        name: 'Climate change',
        flag: '',
      },
      {
        appId: 'Env Opportunities (L2)',
        label: 'Env Opportunities',
        date: '2023-03-31',
        name: 'Environment opportunities - technology, green energy, sustainability',
        flag: '',
      },
      {
        appId: 'Natural Capital (L2)',
        label: 'Natural Capital',
        date: '2022-09-30',
        name: 'Natural Capital - natural assets in their role of providing natural resource inputs and environmenta',
        flag: '',
      },
      {
        appId: 'Toxic Emissions & Waste',
        label: 'Toxic Emissions & Waste',
        date: '2022-08-31',
        name: 'Toxic emissions and waste',
        flag: '',
      },
      {
        appId: 'Packaging Materials & Waste',
        label: 'Packaging Materials & Waste',
        date: '2021-11-30',
        name: 'The waste that consists of packaging materials, its handling, disposal and recycling  ',
        flag: '',
      },
      {
        appId: 'Pollution & Waste (L2)',
        label: 'Pollution & Waste',
        date: '2022-01-31',
        name: 'Pollution & Waste - focusing on industry products',
        flag: '',
      },
      {
        appId: 'Build Back Better',
        label: 'Build Back Better',
        date: '2023-03-31',
        name: 'The money that is spent on welfare payments',
        flag: '',
      },
      {
        appId: 'Physical Infrastructure Spending',
        label: 'Physical Infrastructure Spending',
        date: '2021-12-31',
        name: 'Refers to the spending on basic physical structures required for an economy to function and survive,',
        flag: '',
      },
      {
        appId: 'Coal',
        label: 'Coal',
        date: '2022-04-30',
        name: 'Coal is a sedimentary rock that can be burned for fuel and used to generate electricity',
        flag: '',
      },
      {
        appId: 'Monetary Policy',
        label: 'Monetary Policy',
        date: '2022-12-31',
        name: 'Monetary policy is conducted by central banks, e.g., ECB and US Federal Reserve. It affects all of t',
        flag: '',
      },
      {
        appId: 'NFT',
        label: 'NFT',
        date: '2022-04-30',
        name: 'A non-fungible token is a unique digital identifier that cannot be copied, substituted, or subdivide',
        flag: '',
      },
      {
        appId: 'Natural Gas',
        label: 'Natural Gas',
        date: '2023-01-31',
        name: 'Natural gas price',
        flag: '',
      },
      {
        appId: 'Inflation: Transportation',
        label: 'Inflation: Transportation',
        date: '2022-08-31',
        name: 'Transportation - prices and costs',
        flag: '',
      },
      {
        appId: 'Household Goods Prices',
        label: 'Household Goods Prices',
        date: '2022-07-31',
        name: 'Household goods price inflation',
        flag: '',
      },
      {
        appId: 'Healthcare Prices',
        label: 'Healthcare Prices',
        date: '2022-11-30',
        name: 'Healthcare cost Inflation',
        flag: '',
      },
      {
        appId: 'Wearable Tech',
        label: 'Wearable Tech',
        date: '2022-02-28',
        name: 'Wearable technology is any technology that is designed to be used while worn by a person',
        flag: '',
      },
      {
        appId: 'Metaverse',
        label: 'Metaverse',
        date: '2022-04-30',
        name: 'A metaverse is a digital place inhabited by digital representations of people, places, and things',
        flag: '',
      },
      {
        appId: 'Pollution Prevention',
        label: 'Pollution Prevention',
        date: '2021-11-30',
        name: 'Pollution prevention is a strategy for reducing the amount of waste created and released into the en',
        flag: '',
      },
      {
        appId: 'New Energy',
        label: 'New Energy',
        date: '2022-09-30',
        name: 'New energy - wind, solar, bio, hydro, geothermal, Electrochemical, smart energy management',
        flag: '',
      },
      {
        appId: 'Water',
        label: 'Water',
        date: '2023-02-28',
        name: 'Water equipment, technology, treatment, service, supply, infrastructure',
        flag: '',
      },
      {
        appId: 'Meme Stocks',
        label: 'Meme Stock',
        date: '2022-09-30',
        name: 'A meme stock is a stock that gains popularity among retail investors through social media',
        flag: '',
      },
      {
        appId: 'Web3',
        label: 'Web3',
        date: '2022-11-30',
        name: 'Web3 is the idea for a new iteration of the World Wide Web which incorporates concepts such as decen',
        flag: '',
      },
      {
        appId: 'Edge Computing',
        label: 'Edge Computing',
        date: '2022-04-30',
        name: 'Edge computing is a distributed computing paradigm that brings computation and data storage closer t',
        flag: '',
      },
      {
        appId: 'Content Creation',
        label: 'Content Creation',
        date: '2022-02-28',
        name: 'When a person creates entertaining or educational material to be expressed through any medium',
        flag: '',
      },
      {
        appId: 'Quantum Computing',
        label: 'Quantum Computing',
        date: '2022-10-31',
        name: 'Quantum computing is a type of computation whose operations can harness the phenomena of quantum mec',
        flag: '',
      },
      {
        appId: 'DeFi',
        label: 'DeFi',
        date: '2022-06-30',
        name: 'An application that can operate autonomously, that run on a decentralized computing, blockchain or o',
        flag: '',
      },
      {
        appId: 'Digital PaymentsTopic',
        label: 'Digital Payments',
        date: '2023-01-31',
        name: 'The Digital Payment ecosystem',
        flag: '',
      },
      {
        appId: 'Sharing Economy Topic',
        label: 'Sharing Economy',
        date: '2022-10-31',
        name: 'Sharing economy is a socio-economic system built around the sharing of resources',
        flag: '',
      },
      {
        appId: 'Social MediaTopic',
        label: 'Social Media',
        date: '2023-01-31',
        name: 'Social media companies, platforms, networks, users, and usage',
        flag: '',
      },
      {
        appId: '3D PrintingTopic',
        label: '3D Printing',
        date: '2022-02-28',
        name: 'The construction of a three-dimensional object',
        flag: '',
      },
      {
        appId: 'Healthcare InnovationTopic',
        label: 'Healthcare Innovation',
        date: '2023-02-28',
        name: 'Healthcare & Innovation',
        flag: '',
      },
      {
        appId: 'Smart Mobility',
        label: 'Smart Mobility',
        date: '2022-10-31',
        name: 'Smart mobility refers to many modes of transport. Some smart mobility services include: public trans',
        flag: '',
      },
      {
        appId: 'Electric VehicleTopic',
        label: 'Electric Vehicle',
        date: '2023-02-28',
        name: 'Electric vehicle',
        flag: '',
      },
      {
        appId: 'Smart City InfrastructureTopic',
        label: 'Smart City Infrastructure',
        date: '2022-12-31',
        name: 'The infrastructure used in smart city',
        flag: '',
      },
      {
        appId: 'Smart HomeTopic',
        label: 'Smart Home',
        date: '2022-12-31',
        name: 'A smart home refers to a convenient home setup where appliances and devices can be automatically con',
        flag: '',
      },
      {
        appId: 'Health & FitnessTopic',
        label: 'Health & Fitness',
        date: '2022-09-30',
        name: 'Health & Fitness',
        flag: '',
      },
      {
        appId: 'Fashion BrandsTopic',
        label: 'Fashion Brands',
        date: '2022-12-31',
        name: 'Fashion & Brands',
        flag: '',
      },
      {
        appId: 'Energy EfficiencyTopic',
        label: 'Energy Efficiency',
        date: '2022-08-31',
        name: 'Energy efficiency',
        flag: '',
      },
      {
        appId: 'BatteriesTopic',
        label: 'Batteries',
        date: '2022-09-30',
        name: 'Electric battery ecosystem, market and prices',
        flag: '',
      },
      {
        appId: 'Machine LearningTopic',
        label: 'Machine Learning',
        date: '2023-03-31',
        name: 'Machine learning is a subfield of artificial intelligence',
        flag: '',
      },
      {
        appId: 'AutomationTopic',
        label: 'Automation',
        date: '2023-03-31',
        name: 'Technologies that reduce the need of human intervention',
        flag: '',
      },
      {
        appId: 'Water SupplyTopic',
        label: 'Water Supply',
        date: '2022-12-31',
        name: 'Water supply is the provision of water by public utilities, commercial organizations, community ende',
        flag: '',
      },
      {
        appId: 'Water UtilitiesTopic',
        label: 'Water Utilities',
        date: '2022-09-30',
        name: 'The water utilities that provide drinking water and wastewater services to residential, commercial, ',
        flag: '',
      },
      {
        appId: 'Water TreatmentTopic',
        label: 'Water Treatment',
        date: '2022-08-31',
        name: 'Water treatment is any process that improves the quality of water to make it appropriate for a speci',
        flag: '',
      },
      {
        appId: 'Targeted Therapy',
        label: 'Targeted Therapy',
        date: '2022-01-31',
        name: 'Targeted therapy or molecularly targeted therapy is one of the major modalities of medical treatment',
        flag: '',
      },
      {
        appId: 'Gene Therapy',
        label: 'Gene Therapy',
        date: '2022-05-31',
        name: 'Gene therapy is a medical field which focuses on the genetic modification of cells to produce a ther',
        flag: '',
      },
      {
        appId: 'Gene EditingTopic',
        label: 'Gene Editing',
        date: '2022-10-31',
        name: 'Gene editing',
        flag: '',
      },
      {
        appId: 'Blockchain',
        label: 'Blockchain',
        date: '2022-02-28',
        name: 'Blockchain is a digital ledger of transactions that is duplicated and distributed across the entire ',
        flag: '',
      },
      {
        appId: 'P2P',
        label: 'P2P',
        date: '2022-02-28',
        name: 'Peer-to-peer computing or networking is a distributed application architecture that partitions tasks',
        flag: '',
      },
      {
        appId: 'Healthcare Analytics',
        label: 'Healthcare Analytics',
        date: '2022-04-30',
        name: 'Healthcare analytics - bioinformatic',
        flag: '',
      },
      {
        appId: 'Space ExplorationTopic',
        label: 'Space Exploration',
        date: '2021-11-30',
        name: 'Space exploration is the use of astronomy and space technology to explore outer space',
        flag: '',
      },
      {
        appId: 'Aging Disease Treatment',
        label: 'Aging Disease Treatment',
        date: '2022-12-31',
        name: 'Treatment and medical solutions to handle aging population',
        flag: '',
      },
      {
        appId: 'Aging Insurance',
        label: 'Aging Insurance',
        date: '2022-08-31',
        name: 'An adults insurance that covers the risk of a person incurring medical expenses',
        flag: '',
      },
      {
        appId: 'Farm To Fork',
        label: 'Farm To Fork',
        date: '2022-06-30',
        name: 'Serving local food, preferably through direct acquisition from the producer',
        flag: '',
      },
      {
        appId: 'Plant Based Food',
        label: 'Plant Based Food',
        date: '2022-10-31',
        name: 'Food products made from vegetarian or vegan ingredients, eaten as a replacement for meat',
        flag: '',
      },
      {
        appId: 'Digital LearningTopic',
        label: 'Digital Learning',
        date: '2021-11-30',
        name: 'The Digital Learning ecosystem',
        flag: '',
      },
      {
        appId: 'Student Services',
        label: 'Student Services',
        date: '2023-03-31',
        name: 'Student services - loans, housing, accommodations',
        flag: '',
      },
      {
        appId: 'LiDAR',
        label: 'LiDAR',
        date: '2022-02-28',
        name: 'Light Detection and Ranging - a method for determining ranges',
        flag: '',
      },
      {
        appId: 'Human Capital Development',
        label: 'Human Capital Development',
        date: '2022-02-28',
        name: 'Human capital development, training',
        flag: '',
      },
      {
        appId: 'Datafication',
        label: 'Datafication',
        date: '2023-03-31',
        name: 'Datafication is a technological trend turning many aspects of our life into data which is subsequent',
        flag: '',
      },
      {
        appId: 'Plastic End Of Life Solutions',
        label: 'Plastic End Of Life Solutions',
        date: '2022-10-31',
        name: 'Recycling and energy recovery (incineration). Taking into account the polymeric waste',
        flag: '',
      },
      {
        appId: 'Satellite Technology',
        label: 'Satellite Technology',
        date: '2022-10-31',
        name: 'Satellite Technology',
        flag: '',
      },
      {
        appId: 'Drones',
        label: 'Drones',
        date: '2023-03-31',
        name: 'An unmanned aerial vehicle, commonly known as a drone, is an aircraft without any human pilot, crew,',
        flag: '',
      },
      {
        appId: 'Urban Air Mobility',
        label: 'Urban Air Mobility',
        date: '2022-09-30',
        name: 'Urban Air Mobility is the use of small, highly automated aircraft to carry passengers or cargo at lo',
        flag: '',
      },
      {
        appId: 'Monkeypox',
        label: 'Monkeypox',
        date: '2022-09-30',
        name: 'Monkeypox is an infectious viral disease that can occur in humans and some other animals',
        flag: '',
      },
      {
        appId: 'Abortions',
        label: 'Abortions',
        date: '2022-11-30',
        name: 'The termination of a pregnancy',
        flag: '',
      },
      {
        appId: 'Satellite Web',
        label: 'Satellite Web',
        date: '2022-12-31',
        name: 'A web with a goal to provide global broadband internet services via satellites',
        flag: '',
      },
      {
        appId: 'Content Moderation',
        label: 'Content Moderation',
        date: '2022-10-31',
        name: 'The process of ensuring user-generated content is holding to the Social/Media platform rules and gui',
        flag: '',
      },
      {
        appId: 'RSV',
        label: 'RSV',
        date: '2023-01-31',
        name: 'Respiratory Syncytial Virus',
        flag: '',
      },
      {
        appId: 'Energy Crisis',
        label: 'Energy Crisis',
        date: '2022-11-30',
        name: 'Any significant bottleneck in the supply of energy resources to an economy',
        flag: '',
      },
      {
        appId: 'Consumer Financial Protection',
        label: 'Consumer Financial Protection',
        date: '2023-03-31',
        name: 'Protecting consumers and their funds from financial crimes',
        flag: '',
      },
      {
        appId: 'Social Opportunities',
        label: 'Social Opportunities',
        date: '2023-03-31',
        name: 'Opportunities and problems in society - communications, health and diet, finance',
        flag: '',
      },
      {
        appId: 'Chatbot',
        label: 'Chatbot',
        date: '2023-03-31',
        name: 'Chatbot is a software application used to conduct an online chat conversation via text or text-to-sp',
        flag: '',
      },
    ],
  },
  {
    category: 'Baskets',
    type: 'arrowString',
    path: '',
    data: [
      {
        name: 'Megatrends Rotation',
        icon: '',
        path: '/Dashboards%20&%20Apps/Apps/MegatrendsModel',
        data: [
          'Aging Society',
          'Autonomous Technology',
          'Cybersecurity',
          'Digital Economy',
          'Digital Health',
          'Disruptive Technology',
          'Efficient Energy',
          'Fintech',
          'Food Revolution',
          'Future Education',
          'Future Mobility',
          'Genomic Innovation',
          'Millennials',
          'Internet Innovation',
          'Robotics',
          'Smart Cities',
        ],
      },
    ],
  },
  {
    category: 'FX',
    type: 'keyValue',
    path: '/Explore/FX?Label={label}',
    data: [
      {
        label: 'ARS',
        name: 'Argentina',
        flag: 'AR',
      },
      {
        label: 'AUD',
        name: 'Australia Dollar',
        flag: 'AU',
      },
      {
        label: 'BRL',
        name: 'Brazil',
        flag: 'BR',
      },
      {
        label: 'CAD',
        name: 'Canadian Dollar',
        flag: 'CA',
      },
      {
        label: 'CNY',
        name: 'Chinese Yuan',
        flag: 'CN',
      },
      {
        label: 'COP',
        name: 'Colombia',
        flag: 'CO',
      },
      {
        label: 'DKK',
        name: 'Danish Krone',
        flag: 'DK',
      },
      {
        label: 'EGP',
        name: 'Egypt',
        flag: 'EG',
      },
      {
        label: 'EUR',
        name: 'Euro',
        flag: 'FR',
      },
      {
        label: 'EUR',
        name: 'Euro',
        flag: 'DE',
      },
      {
        label: 'EUR',
        name: 'Euro',
        flag: 'GR',
      },
      {
        label: 'HKD',
        name: 'Hong Kong Dollar',
        flag: 'HK',
      },
      {
        label: 'INR',
        name: 'Indian Rupee',
        flag: 'IN',
      },
      {
        label: 'IDR',
        name: 'Indonesia',
        flag: 'ID',
      },
      {
        label: 'EUR',
        name: 'Euro',
        flag: 'IE',
      },
      {
        label: 'ILS',
        name: 'Israel',
        flag: 'IL',
      },
      {
        label: 'EUR',
        name: 'Euro',
        flag: 'IT',
      },
      {
        label: 'JPY',
        name: 'Japanese Yen',
        flag: 'JP',
      },
      {
        label: 'KRW',
        name: 'Korea',
        flag: 'KR',
      },
      {
        label: 'EUR',
        name: 'Euro',
        flag: 'LV',
      },
      {
        label: 'MYR',
        name: 'Malaysia',
        flag: 'MY',
      },
      {
        label: 'MXN',
        name: 'Mexican Peso',
        flag: 'MX',
      },
      {
        label: 'EUR',
        name: 'Euro',
        flag: 'NL',
      },
      {
        label: 'NZD',
        name: 'New Zealand Dollar',
        flag: 'NZ',
      },
      {
        label: 'NGN',
        name: 'Nigeria',
        flag: 'NG',
      },
      {
        label: 'NOK',
        name: 'Norwegian Krone',
        flag: 'NO',
      },
      {
        label: 'PHP',
        name: 'Philippines',
        flag: 'PH',
      },
      {
        label: 'PLN',
        name: 'Polish Zloty',
        flag: 'PL',
      },
      {
        label: 'EUR',
        name: 'Euro',
        flag: 'PT',
      },
      {
        label: 'RUB',
        name: 'Russian Ruble',
        flag: 'RU',
      },
      {
        label: 'SGD',
        name: 'Singapore Dollar',
        flag: 'SG',
      },
      {
        label: 'ZAR',
        name: 'South African Rand',
        flag: 'ZA',
      },
      {
        label: 'EUR',
        name: 'Euro',
        flag: 'ES',
      },
      {
        label: 'SEK',
        name: 'Swedish Krona',
        flag: 'SE',
      },
      {
        label: 'CHF',
        name: 'Swiss Franc',
        flag: 'CH',
      },
      {
        label: 'THB',
        name: 'Thailand',
        flag: 'TH',
      },
      {
        label: 'TRY',
        name: 'Turkish Lira',
        flag: 'TR',
      },
      {
        label: 'GBP',
        name: 'British Pound',
        flag: 'GB',
      },
      {
        label: 'USD',
        name: 'American Dollar',
        flag: 'US',
      },
      {
        label: 'EUR',
        name: 'Euro',
        flag: 'EU',
      },
    ],
  },
  {
    category: 'Crypto',
    type: 'keyValue',
    path: '/Asset%20Class%20Views/Cryptos/Crypto%20Social%20Monitor',
    data: [
      {
        label: 'GMT',
        name: 'STEPN',
      },
      {
        label: 'KCS',
        name: 'KuCoin Token',
      },
      {
        label: 'APE',
        name: 'ApeCoin',
      },
      {
        label: 'BTCB',
        name: 'Bitcoin BEP2',
      },
      {
        label: 'USTC',
        name: 'TerraClassicUSD',
      },
      {
        label: 'CEL',
        name: 'Celsius',
      },
      {
        label: 'SEELE',
        name: 'Seele-N',
      },
      {
        label: 'BDX',
        name: 'Beldex',
      },
      {
        label: 'THX',
        name: 'ThoreNext',
      },
      {
        label: 'THR',
        name: 'ThoreCoin',
      },
      {
        label: 'PZM',
        name: 'PRIZM',
      },
      {
        label: 'INB',
        name: 'Insight Chain',
      },
      {
        label: 'INO',
        name: 'Ino Coin',
      },
      {
        label: 'HEDG',
        name: 'HedgeTrade',
      },
      {
        label: 'MIN',
        name: 'MINDOL',
      },
      {
        label: '999',
        name: '999',
      },
      {
        label: 'HT',
        name: 'Huobi Token',
      },
      {
        label: 'LEO',
        name: 'UNUS SED LEO',
      },
      {
        label: 'GUSD',
        name: 'Gemini Dollar',
      },
      {
        label: 'AE',
        name: 'Æternity',
      },
      {
        label: 'REV',
        name: 'Revain',
      },
      {
        label: 'BCD',
        name: 'Bitcoin Diamond',
      },
      {
        label: 'MONA',
        name: 'MonaCoin',
      },
      {
        label: 'FCT',
        name: 'Factom',
      },
      {
        label: 'PIVX',
        name: 'PIVX',
      },
      {
        label: 'NXT',
        name: 'Nxt',
      },
      {
        label: 'SALT',
        name: 'SALT',
      },
      {
        label: 'VERI',
        name: 'Veritaseum',
      },
      {
        label: 'ARK',
        name: 'Ark',
      },
      {
        label: 'GLM',
        name: 'Golem',
      },
      {
        label: 'SNT',
        name: 'Status',
      },
      {
        label: 'STEEM',
        name: 'Steem',
      },
      {
        label: 'BCN',
        name: 'Bytecoin',
      },
      {
        label: 'HC',
        name: 'HyperCash',
      },
      {
        label: 'PPT',
        name: 'Populous',
      },
      {
        label: 'BCC',
        name: 'BitConnect',
      },
      {
        label: 'ZRX',
        name: '0x',
      },
      {
        label: 'ZIL',
        name: 'Zilliqa',
      },
      {
        label: 'ZEC',
        name: 'Zcash',
      },
      {
        label: 'YFI',
        name: 'yearn.finance',
      },
      {
        label: 'XVG',
        name: 'Verge',
      },
      {
        label: 'XEC',
        name: 'eCash',
      },
      {
        label: 'WTC',
        name: 'Waltonchain',
      },
      {
        label: 'WAVES',
        name: 'Waves',
      },
      {
        label: 'WAN',
        name: 'Wanchain',
      },
      {
        label: 'VGX',
        name: 'Voyager Token',
      },
      {
        label: 'USDP',
        name: 'Pax Dollar',
      },
      {
        label: 'UMA',
        name: 'UMA',
      },
      {
        label: 'TUSD',
        name: 'TrueUSD',
      },
      {
        label: 'TFUEL',
        name: 'Theta Fuel',
      },
      {
        label: 'SUSHI',
        name: 'SushiSwap',
      },
      {
        label: 'STRAX',
        name: 'Stratis',
      },
      {
        label: 'SNX',
        name: 'Synthetix',
      },
      {
        label: 'SHIB',
        name: 'Shiba Inu',
      },
      {
        label: 'SC',
        name: 'Siacoin',
      },
      {
        label: 'SAND',
        name: 'The Sandbox',
      },
      {
        label: 'RVN',
        name: 'Ravencoin',
      },
      {
        label: 'RUNE',
        name: 'THORChain',
      },
      {
        label: 'REP',
        name: 'Augur',
      },
      {
        label: 'REN',
        name: 'Ren',
      },
      {
        label: 'QTUM',
        name: 'Qtum',
      },
      {
        label: 'QNT',
        name: 'Quant',
      },
      {
        label: 'NPXS',
        name: 'Pundi X (Old)',
      },
      {
        label: 'ONT',
        name: 'Ontology',
      },
      {
        label: 'ONE',
        name: 'Harmony',
      },
      {
        label: 'OMG',
        name: 'OMG Network',
      },
      {
        label: 'NEAR',
        name: 'NEAR Protocol',
      },
      {
        label: 'XNO',
        name: 'Nano',
      },
      {
        label: 'MKR',
        name: 'Maker',
      },
      {
        label: 'MITH',
        name: 'Mithril',
      },
      {
        label: 'MANA',
        name: 'Decentraland',
      },
      {
        label: 'LSK',
        name: 'Lisk',
      },
      {
        label: 'LRC',
        name: 'Loopring',
      },
      {
        label: 'KNC',
        name: 'Kyber Network Crystal v2',
      },
      {
        label: 'KMD',
        name: 'Komodo',
      },
      {
        label: 'KLAY',
        name: 'Klaytn',
      },
      {
        label: 'IOST',
        name: 'IOST',
      },
      {
        label: 'ICX',
        name: 'ICON',
      },
      {
        label: 'ICP',
        name: 'Internet Computer',
      },
      {
        label: 'HOT',
        name: 'Holo',
      },
      {
        label: 'HNT',
        name: 'Helium',
      },
      {
        label: 'GRT',
        name: 'The Graph',
      },
      {
        label: 'GALA',
        name: 'Gala',
      },
      {
        label: 'FTM',
        name: 'Fantom',
      },
      {
        label: 'FLOW',
        name: 'Flow',
      },
      {
        label: 'ETC',
        name: 'Ethereum Classic',
      },
      {
        label: 'ELF',
        name: 'aelf',
      },
      {
        label: 'EGLD',
        name: 'Elrond',
      },
      {
        label: 'DGB',
        name: 'DigiByte',
      },
      {
        label: 'DCR',
        name: 'Decred',
      },
      {
        label: 'DASH',
        name: 'Dash',
      },
      {
        label: 'COMP',
        name: 'Compound',
      },
      {
        label: 'CELO',
        name: 'Celo',
      },
      {
        label: 'CAKE',
        name: 'PancakeSwap',
      },
      {
        label: 'BTS',
        name: 'BitShares',
      },
      {
        label: 'BTG',
        name: 'Bitcoin Gold',
      },
      {
        label: 'BAT',
        name: 'Basic Attention Token',
      },
      {
        label: 'AXS',
        name: 'Axie Infinity',
      },
      {
        label: 'ARDR',
        name: 'Ardor',
      },
      {
        label: 'AMP',
        name: 'Amp',
      },
      {
        label: 'FIL',
        name: 'Filecoin',
      },
      {
        label: 'LUNA',
        name: 'Terra',
      },
      {
        label: 'USDC',
        name: 'USD Coin',
      },
      {
        label: 'XEM',
        name: 'NEM',
      },
      {
        label: 'HBAR',
        name: 'Hedera',
      },
      {
        label: 'DAI',
        name: 'Dai',
      },
      {
        label: 'CHZ',
        name: 'Chiliz',
      },
      {
        label: 'ALGO',
        name: 'Algorand',
      },
      {
        label: 'NEO',
        name: 'Neo',
      },
      {
        label: 'XTZ',
        name: 'Tezos',
      },
      {
        label: 'BUSD',
        name: 'Binance USD',
      },
      {
        label: 'BTTOLD',
        name: 'BitTorrent',
      },
      {
        label: 'FTT',
        name: 'FTX Token',
      },
      {
        label: 'AVAX',
        name: 'Avalanche',
      },
      {
        label: 'KSM',
        name: 'Kusama',
      },
      {
        label: 'EOS',
        name: 'EOS',
      },
      {
        label: 'ATOM',
        name: 'Cosmos',
      },
      {
        label: 'BSV',
        name: 'Bitcoin SV',
      },
      {
        label: 'AAVE',
        name: 'Aave',
      },
      {
        label: 'MIOTA',
        name: 'IOTA',
      },
      {
        label: 'MATIC',
        name: 'Polygon',
      },
      {
        label: 'TRX',
        name: 'TRON',
      },
      {
        label: 'THETA',
        name: 'Theta Network',
      },
      {
        label: 'USDT',
        name: 'Tether',
      },
      {
        label: 'WBTC',
        name: 'Wrapped Bitcoin',
      },
      {
        label: 'SOL',
        name: 'Solana',
      },
      {
        label: 'VET',
        name: 'VeChain',
      },
      {
        label: 'DOGE',
        name: 'Dogecoin',
      },
      {
        label: 'UNI',
        name: 'Uniswap',
      },
      {
        label: 'BNB',
        name: 'BNB',
      },
      {
        label: 'XMR',
        name: 'Monero',
      },
      {
        label: 'LINK',
        name: 'Chainlink',
      },
      {
        label: 'XLM',
        name: 'Stellar',
      },
      {
        label: 'BCH',
        name: 'Bitcoin Cash',
      },
      {
        label: 'LTC',
        name: 'Litecoin',
      },
      {
        label: 'DOT',
        name: 'Polkadot',
      },
      {
        label: 'ADA',
        name: 'Cardano',
      },
      {
        label: 'XRP',
        name: 'XRP',
      },
      {
        label: 'ETH',
        name: 'Ethereum',
      },
      {
        label: 'BTC',
        name: 'Bitcoin',
      },
      {
        label: 'GAS',
        name: 'Gas',
      },
      {
        label: 'REV',
        name: 'RChain',
      },
      {
        label: 'DGD',
        name: 'DigixDAO',
      },
      {
        label: 'ETN',
        name: 'Electroneum',
      },
      {
        label: 'BTM',
        name: 'Bytom',
      },
      {
        label: 'XIN',
        name: 'Mixin',
      },
      {
        label: 'BTCP',
        name: 'Bitcoin Private',
      },
      {
        label: 'ETP',
        name: 'Metaverse ETP',
      },
      {
        label: 'AOA',
        name: 'Aurora',
      },
      {
        label: 'ABBC',
        name: 'ABBC Coin',
      },
      {
        label: 'CRO',
        name: 'Cronos',
      },
      {
        label: 'MXM',
        name: 'MXM Token',
      },
      {
        label: 'EKT',
        name: 'EDUCare',
      },
      {
        label: 'OSC',
        name: 'Oasis City',
      },
      {
        label: 'ZB',
        name: 'ZB Token',
      },
      {
        label: 'VSYS',
        name: 'v.systems',
      },
      {
        label: 'MEXC',
        name: 'MEXC Token',
      },
      {
        label: 'CENNZ',
        name: 'CENNZnet',
      },
      {
        label: 'XET',
        name: 'ETERNAL TOKEN',
      },
      {
        label: 'FLG',
        name: 'Folgory Coin',
      },
      {
        label: 'DNA',
        name: 'Metaverse Dualchain Network Architecture',
      },
      {
        label: 'PLF',
        name: 'PlayFuel',
      },
      {
        label: 'OKB',
        name: 'OKB',
      },
      {
        label: 'BRC',
        name: 'Baer Chain',
      },
      {
        label: 'BAY',
        name: 'BitBay',
      },
      {
        label: 'ELAMA',
        name: 'Elamachain',
      },
      {
        label: 'TAGZ5',
        name: 'TAGZ5',
      },
      {
        label: 'CCXX',
        name: 'Counos X',
      },
      {
        label: 'HEX',
        name: 'HEX',
      },
      {
        label: 'MWC',
        name: 'MimbleWimbleCoin',
      },
      {
        label: 'TNC',
        name: 'TNC Coin',
      },
      {
        label: 'TMTG',
        name: 'The Midas Touch Gold',
      },
      {
        label: 'VEST',
        name: 'VestChain',
      },
      {
        label: 'ACA',
        name: 'Acash Coin',
      },
      {
        label: 'BPS',
        name: 'BitcoinPoS',
      },
      {
        label: 'AMPL',
        name: 'Ampleforth',
      },
    ],
  },
  {
    category: 'Dashboards',
    type: 'arrowString',
    path: '',
    data: [
      {
        name: 'Select Narratives',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/General/Select%20Narratives',
        data: [
          'Armed Conflict',
          'Brexit',
          'COVID19',
          'Civil Unrest',
          'Consumer Savings',
          'Consumer Spending',
          'Crowded Trades',
          'Earning Season',
          'Fiscal Stimulus',
          'GDP',
          'Global Growth',
          'Inflation',
          'International Conflict',
          'Iran',
          'Irrational Exuberance',
          'Labor Market',
          'Liquidity',
          'Market Crash',
          'Monetary Stimulus',
          'Oil',
          'Pent Up Demand',
          'Recession',
          'SPAC',
          'Short Squeeze',
          'Shortage',
          'Trade Tension',
          'US Growth',
          'Volatility',
        ],
      },
      {
        name: 'Inflation',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/General/Inflation',
        data: [
          'Apparel Prices',
          'Breakeven Inflation',
          'Construction Materials Prices',
          'Devaluation',
          'Dairy Prices',
          'Disinflation',
          'Drug Prices',
          'FED Persistent',
          'FED Transitory',
          'FED Extension / Twist',
          'FED QE',
          'FED QT',
          'FED Rate Cut',
          'FED Rate Hike',
          'FED Tapering',
          'Food Prices',
          'Fruit & Vegetable Prices',
          'Gasoline Price',
          'Healthcare Prices',
          'Household Goods Prices',
          'Hyperinflation',
          'Inflation',
          'Deflation',
          'Meat Prices',
          'Nominal Rates',
          'Real Rates',
          'Reflation',
          'Stagflation',
          'Inflation: Transportation',
        ],
      },
      {
        name: 'Shortage',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/General/Shortage',
        data: [
          'Baby Formula Shortage',
          'Chip Shortage',
          'Coal Shortage',
          'Container Shortage',
          'Egg Shortage',
          'Food Shortage',
          'Fruit & Vegetable Shortage',
          'Fuel Shortage',
          'Labor Shortage',
          'Lumber Shortage',
          'Meat Shortage',
          'Natural Gas Shortage',
          'Shortage',
        ],
      },
      {
        name: 'COVID-19',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/General/Covid19',
        data: [
          'COVID19',
          'China Economy',
          'Corona Virus Solution',
          'Eurozone Economy',
          'General Recovery',
          'Global Economy',
          'Panic',
          'Reopening Too Soon',
          'US Economy',
          'Mutation',
          'Vaccine Complications',
          'Vaccine Conspiracy',
          'Vaccine Logistics',
          'Vaccine Skepticism',
          'BA.2',
          'Delta',
          'Omicron',
          'Test Shortage',
          'Hospital Bed Shortage',
          'ICU Shortage',
        ],
      },
      {
        name: 'ESG',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/General/ESG',
        data: [
          'Biodiversity & Land Use',
          'Carbon Emissions',
          'Carbon Footprint',
          'Renewable Energy',
          'Clean Tech',
          'Climate Change Vulnerability',
          'Electronic Waste',
          'Financing Env Impact',
          'Green Building',
          'Climate Change (L2)',
          'Env Opportunities (L2)',
          'Natural Capital (L2)',
          'Pollution & Waste (L2)',
          'Packaging Materials & Waste',
          'Raw Material Sourcing',
          'Toxic Emissions & Waste',
          'Water Stress',
        ],
      },
      {
        name: 'Natural Disasters',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/General/Natural%20Disasters',
        data: [
          'Cyclones',
          'Droughts',
          'Earthquakes',
          'Floods',
          'Hurricanes',
          'Oil Spill',
          'Snow Storm',
          'Tornados',
          'Tsunamis',
          'Typhoons',
          'Volcanic Eruptions',
          'Wildfires',
        ],
      },
      {
        name: 'Central Banks',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/General/Central%20Banks',
        data: [
          'BOC',
          'BOJ',
          'CBBR',
          'BOE',
          'BMXO',
          'BOK',
          'CBRT',
          'ECB',
          'FED',
          'NORBK',
          'PBOC',
          'RBA',
          'RBNZ',
          'RIKBK',
          'SARB',
          'SNB',
        ],
      },
      {
        name: 'Factors',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/Asset%20Classes/Factors',
        data: [
          'Dividends',
          'EAFE',
          'Emerging Markets',
          'Gold',
          'Minimum Volatility',
          'Momentum',
          'Oil',
          'Quality Factor',
          'Small Size Factor',
          'Treasury Bonds: USA',
          'US Stock Market',
          'Value Factor',
        ],
      },
      {
        name: 'Commodities',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/Asset%20Classes/Commodities',
        data: [
          'Dividends',
          'EAFE',
          'Emerging Markets',
          'Gold',
          'Minimum Volatility',
          'Momentum',
          'Oil',
          'Quality Factor',
          'Small Size Factor',
          'Treasury Bonds: USA',
          'US Stock Market',
          'Value Factor',
        ],
      },
      {
        name: 'Megatrends',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/Custom/Megatrends',
        data: [
          'Aging Society',
          'Autonomous Technology',
          'Cybersecurity',
          'Digital Economy',
          'Digital Health',
          'Disruptive Technology',
          'Efficient Energy',
          'Fintech',
          'Food Revolution',
          'Future Education',
          'Future Mobility',
          'Genomic Innovation',
          'Millennials',
          'Internet Innovation',
          'Robotics',
          'Smart Cities',
        ],
      },
      {
        name: 'Custom ETFs',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/Custom/Custom1%20ETFs',
        data: [
          'Digital Economy',
          'Disruptive Technology',
          'Future Mobility',
          'Millennials',
          'New Energy',
          'Robotics & AI',
          'Smart Cities',
          'Water',
        ],
      },
      {
        name: 'Digital Transformation',
        icon: 'BarChart',
        path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/Custom/Digital',
        data: [
          '6 G',
          'Crypto',
          'Cybersecurity',
          'DAO',
          'Datafication',
          'De Fi',
          'Cloud Computing',
          'Digital Payments',
          'ECommerce',
          'Digital Trust',
          'Targeted Marketing',
          'NFT',
          'Blockchain',
          'IoT',
          'P2 P',
          'Automation',
          'Machine Learning',
          'Robotics',
          'Web3',
          'Work From Home',
        ],
      },
      {
        name: 'Select Narratives Exposures',
        icon: 'Shield',
        path: '/Narratives%20by%20MediaStats/Risk%20&%20Analytics/Risk:Editor',
        data: [
          'Brexit',
          'China Growth Slowdown',
          'COVID19',
          'Cyclones',
          'Droughts',
          'Earthquakes',
          'ESG Climate Change',
          'Floods',
          'GDP',
          'Gun Laws',
          'Healthcare',
          'Hurricanes',
          'Immigration',
          'Iran',
          'Biden',
          'Large Storms',
          'Market Crash',
          'Oil',
          'Oil Spill',
          'Privacy',
          'Recession',
          'Tornados',
          'Trade War',
          'Trump',
          'Tsunamis',
          'Typhoons',
          'Volcanic Eruptions',
          'Wildfires',
        ],
      },
      {
        name: 'ESG Exposures',
        icon: 'Shield',
        path: '/Narratives%20by%20MediaStats/Risk%20&%20Analytics/Risk:ESG',
        data: [
          'Brexit',
          'China Growth Slowdown',
          'COVID19',
          'Cyclones',
          'Droughts',
          'Earthquakes',
          'ESG Climate Change',
          'Floods',
          'GDP',
          'Gun Laws',
          'Healthcare',
          'Hurricanes',
          'Immigration',
          'Iran',
          'Biden',
          'Large Storms',
          'Market Crash',
          'Oil',
          'Oil Spill',
          'Privacy',
          'Recession',
          'Tornados',
          'Trade War',
          'Trump',
          'Tsunamis',
          'Typhoons',
          'Volcanic Eruptions',
          'Wildfires',
        ],
      },
      {
        name: 'Military Escalation',
        icon: 'Language',
        path: '/Narratives%20by%20MediaStats/Geopolitics/Military%20Escalation',
        data: [
          'Armed Conflict',
          'Ceasefire',
          'China Conflict',
          'Cyberattack',
          'Iran Conflict',
          'Israel Conflict',
          'Biden',
          'Libya Conflict',
          'Natural Gas',
          'Nickel',
          'North Korea  Conflict',
          'Nuclear',
          'Oil',
          'Putin',
          'Russia Conflict',
          'Sanctions',
          'Syria Conflict',
          'Taiwan Conflict',
          'Trump',
          'Ukraine Conflict',
          'Wheat',
          'Zelenskyy',
        ],
      },
      {
        name: 'Equity Fundamentals: By Sector',
        icon: 'LineStyle',
        path: '/Asset%20Class%20Views/Equity%20Fundamentals/Bottom-up%20by%20Sector',
        data: [
          'Analyst Estimates',
          'Analyst Estimates',
          'Beat / Miss Analyst Estimates',
          'Buybacks Growth',
          'Capex Growth',
          'Dividend Growth',
          'Earnings Growth',
          'Hiring Growth',
          'M&A',
          'Management Guidance',
          'Management Turnover',
          'Revenue Growth',
          'Tax Growth',
        ],
      },
      {
        name: 'Equity Fundamentals: By Region',
        icon: 'LineStyle',
        path: '/Asset%20Class%20Views/Equity%20Fundamentals/Bottom-up%20by%20Region',
        data: [
          'Analyst Estimates',
          'Analyst Estimates',
          'Beat / Miss Analyst Estimates',
          'Buybacks Growth',
          'Capex Growth',
          'Dividend Growth',
          'Earnings Growth',
          'Hiring Growth',
          'M&A',
          'Management Guidance',
          'Management Turnover',
          'Revenue Growth',
          'Tax Growth',
        ],
      },
      {
        name: 'Commodities',
        icon: 'LocalGasStation',
        path: '/Asset%20Class%20Views/Commodities/Commodities',
        data: [
          'Aluminium',
          'Cattle',
          'Coal',
          'Coffee',
          'Copper',
          'Corn',
          'Gold',
          'Iron Ore',
          'Lumber',
          'Nickel',
          'Oil',
          'Silver',
          'Soybean',
          'Steel',
          'Sugar',
          'Wheat',
        ],
      },
      {
        name: 'Crypto',
        icon: 'Bitcoin',
        path: '/Asset%20Class%20Views/Cryptos/Crypto%20Social%20Monitor',
        data: [
          'Binance Coin',
          'Bitcoin',
          'Bitcoin Cash',
          'Cardano',
          'Chainlink',
          'Dogecoin',
          'Ethereum',
          'Litecoin',
          'Monero',
          'Polkadot',
          'Polygon',
          'Ripple',
          'Solana',
          'Stellar',
          'THETA',
          'TRON',
          'Tether',
          'Uniswap',
          'Ve Chain',
          'Wrapped Bitcoin',
        ],
      },
      {
        name: 'Military Escalation Monitor',
        icon: 'Widgets',
        path: '/Dashboards%20&%20Apps/Dashboards/International%20Conflict',
        data: [
          'International Conflict',
          'Militery Escalation',
          'Iran',
          'North Korea',
          'Syria',
          'Israel',
          'Ukraine',
          'Taiwan',
        ],
      },
    ],
  },
  {
    category: 'Banks',
    type: 'keyValue',
    path: '/Narratives%20by%20MediaStats/Quantified%20Narratives/General/Central%20Banks',
    data: [
      {
        name: 'RBA',
        label: 'RBA',
        flag: 'AU',
      },
      {
        name: 'Banco Central Do Brasil',
        label: 'CBBR',
        flag: 'BR',
      },
      {
        name: 'BOC',
        label: 'BOC',
        flag: 'CA',
      },
      {
        name: 'PBOC',
        label: 'PBOC',
        flag: 'CN',
      },
      {
        name: 'BOJ',
        label: 'BOJ',
        flag: 'JP',
      },
      {
        name: 'Banxico',
        label: 'BMXO',
        flag: 'MX',
      },
      {
        name: 'RBNZ',
        label: 'RBNZ',
        flag: 'NZ',
      },
      {
        name: 'Norges Bank',
        label: 'NORBK',
        flag: 'NO',
      },
      {
        name: 'SARB',
        label: 'SARB',
        flag: 'ZA',
      },
      {
        name: 'Riksbank',
        label: 'RIKBK',
        flag: 'SE',
      },
      {
        name: 'SNB',
        label: 'SNB',
        flag: 'CH',
      },
      {
        name: 'CBRT',
        label: 'CBRT',
        flag: 'TR',
      },
      {
        name: 'Bank Of England',
        label: 'BOE',
        flag: 'GB',
      },
      {
        name: 'Federal Reserve',
        label: 'FED',
        flag: 'US',
      },
      {
        name: 'ECB',
        label: 'ECB',
        flag: 'EU',
      },
      {
        name: 'BoK',
        label: 'BOK',
        flag: 'KR',
      },
    ],
  },
];

export const nameColumnWidth = 60;
export const headersTotalWidth = 160;
